import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

import { useMessageItemContext } from '../context';
import { CreatedByProps } from '../types';

function MessageCreatedBy(props: CreatedByProps) {
  const { className, onClick, variant = 'body-short-03', color = 'text-text-secondary' } = props;
  const message = useMessageItemContext();
  const createdBy = message.createdBy?.name;
  const id = message.id;

  return (
    <Box
      className={cn(className, props.onClick ? 'cursor-pointer' : '')}
      data-attr={id}
      onClick={onClick}>
      <Typography color={color} variant={variant}>
        {createdBy}
      </Typography>
    </Box>
  );
}

export default React.memo(MessageCreatedBy);
